import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-daohang",
  "use": "icon-daohang-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-daohang\"><defs><style type=\"text/css\"></style></defs><path d=\"M153.6 366.08l693.76-232.96s23.04-12.8 38.4 2.56c15.36 17.92 2.56 38.4 2.56 38.4l-230.4 696.32s-10.24 20.48-7.68 17.92c-10.24 10.24-25.6 10.24-35.84 0-10.24-10.24-10.24-17.92-10.24-17.92l-102.4-348.16-348.16-102.4s-7.68 0-17.92-10.24c-10.24-10.24-10.24-25.6 0-35.84-2.56 2.56 17.92-7.68 17.92-7.68z\" p-id=\"1157\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/daohang.svg
// module id = Gpt/
// module chunks = 16